import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchFedwireWithdrawTransaction from '@/hooks/useApi/useFetchFedwireWithdrawTransaction';
import FedwireWithdrawalTransactionInfo from './FedwireWithdrawalTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
  jwt: string;
};
type FC = FunctionComponent<TransactionProps>;

const FedwireWithdrawalContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes, jwt } = props;
  const { userSettings } = useUserSettingsProvider();
  const [FedwireWithdrawTransaction, getFedwireWithdrawTransaction] = useFetchFedwireWithdrawTransaction({
    bearer: jwt,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.FedwireTransactionResponse>();

  useEffect(() => {
    getFedwireWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId]);

  useEffect(() => {
    if (FedwireWithdrawTransaction && FedwireWithdrawTransaction.Success) {
      setTransaction(FedwireWithdrawTransaction);
    }
  }, [FedwireWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>{transaction && <FedwireWithdrawalTransactionInfo transaction={transaction} Notes={Notes} jwt={jwt} />}</div>
  );
};

export default FedwireWithdrawalContainer;
